import { render, staticRenderFns } from "./PaiementMasseNews.vue?vue&type=template&id=5e273bd7&"
import script from "./PaiementMasseNews.vue?vue&type=script&lang=js&"
export * from "./PaiementMasseNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports